var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100%","display":"flex","flex-direction":"column"},attrs:{"id":"app"}},[_c('div',{staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},[_c('router-view')],1),_c('Footer'),_c('GlobalSavingOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }